(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2392],{

/***/ 76031:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$4": function() { return /* binding */ FlagGoodsTmember; },
/* harmony export */   "B2": function() { return /* binding */ FlagGoodsTp; },
/* harmony export */   "G": function() { return /* binding */ FlagGoodsCd; },
/* harmony export */   "X": function() { return /* binding */ FlagEvProgDivi; },
/* harmony export */   "hA": function() { return /* binding */ FlagGoodsBrandCd; },
/* harmony export */   "k0": function() { return /* binding */ FlagEmpasisCd; },
/* harmony export */   "tI": function() { return /* binding */ FlagPromotion; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30202);
/* harmony import */ var _yb_ui_desktop_common_Flag__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29621);
/* harmony import */ var _FRAMEWORK_ui_desktop_flag__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34869);
/* harmony import */ var _goodsUtil__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68284);





/** 상품코드 */ var FlagGoodsCd = function(props) {
    var goodsCd = props.goodsCd;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: goodsCd && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_yb_ui_desktop_common_Flag__WEBPACK_IMPORTED_MODULE_3__/* .Flag */ .W, {
            $type: "code",
            text: goodsCd
        })
    });
};
/** 상품종류 */ var FlagGoodsTp = function(props) {
    var goodsTp = props.goodsTp;
    if (!goodsTp) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    var flag = (0,_goodsUtil__WEBPACK_IMPORTED_MODULE_2__/* .goodsTpLabel */ .mk)(goodsTp);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: flag && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_yb_ui_desktop_common_Flag__WEBPACK_IMPORTED_MODULE_3__/* .Flag */ .W, {
            $type: "product",
            $flag: flag[0],
            text: flag[1]
        })
    });
};
/** 브랜드 */ var FlagGoodsBrandCd = function(props) {
    var goodsBrandCd = props.goodsBrandCd;
    if (!goodsBrandCd) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    var flag = (0,_goodsUtil__WEBPACK_IMPORTED_MODULE_2__/* .goodsBrandCdLabel */ .$b)(goodsBrandCd);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: flag && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_yb_ui_desktop_common_Flag__WEBPACK_IMPORTED_MODULE_3__/* .Flag */ .W, {
            $type: "brand",
            $flag: flag[0],
            text: flag[1]
        })
    });
};
/** 강조 */ var FlagEmpasisCd = function(props) {
    var emphasisCd = props.emphasisCd;
    if (!emphasisCd) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    var flag = (0,_goodsUtil__WEBPACK_IMPORTED_MODULE_2__/* .emphasisCdLabel */ .WV)(emphasisCd);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: flag && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FRAMEWORK_ui_desktop_flag__WEBPACK_IMPORTED_MODULE_1__/* .TagEmp */ .ZP, {
            children: String(flag)
        })
    });
};
/** 여행구성원 */ var FlagGoodsTmember = function(props) {
    var goodsTmember = props.goodsTmember;
    if (!goodsTmember) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    var flag = goodsTmember.split(",")[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: flag && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FRAMEWORK_ui_desktop_flag__WEBPACK_IMPORTED_MODULE_1__/* .TagType */ .Qy, {
            children: flag
        })
    });
};
/** 진행상태 */ var FlagEvProgDivi = function(props) {
    var evProgDivi = props.evProgDivi, evProgDiviNm = props.evProgDiviNm;
    if (!evProgDivi || !evProgDiviNm) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    var flag = (0,_goodsUtil__WEBPACK_IMPORTED_MODULE_2__/* .evProgDiviLabel */ .PL)("key".concat(evProgDivi));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: flag && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FRAMEWORK_ui_desktop_flag__WEBPACK_IMPORTED_MODULE_1__/* .TagProcess */ .N4, {
            flag: flag,
            children: evProgDiviNm
        })
    });
};
/** 프로모션 (옐로라이브)
 *  @description useGlobalGoodsFlag() 미리 호출 필요.
 */ var FlagPromotion = function(props) {
    var ref, ref1, ref2;
    var goodsCd = props.goodsCd;
    if (!goodsCd) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    var queryClient = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_4__/* .useQueryClient */ .NL)();
    var queryData = queryClient.getQueriesData({
        queryKey: [
            "useGlobalGoodsFlag"
        ]
    });
    if (!queryData.length || !((ref = queryData[0]) === null || ref === void 0 ? void 0 : (ref1 = ref[1]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.body) === null || ref2 === void 0 ? void 0 : ref2.PKG)) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    var flagData = queryData[0][1].body.PKG;
    if (!flagData) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    var flagTypes = flagData[goodsCd] && flagData[goodsCd].split(",") || [];
    var flags = flagTypes.reduce(function(acc, cur) {
        if ((0,_goodsUtil__WEBPACK_IMPORTED_MODULE_2__/* .goodsFlag */ .Hw)(cur)) acc.push((0,_goodsUtil__WEBPACK_IMPORTED_MODULE_2__/* .goodsFlag */ .Hw)(cur));
        return acc;
    }, []);
    if (!flags.length) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: flags.map(function(item, index) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_yb_ui_desktop_common_Flag__WEBPACK_IMPORTED_MODULE_3__/* .Flag */ .W, {
                $type: item.$type,
                $flag: item.$flag,
                text: item.text
            }, item.$flag + index);
        })
    });
};



/***/ }),

/***/ 34869:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IO": function() { return /* binding */ TagSquare; },
/* harmony export */   "N4": function() { return /* binding */ TagProcess; },
/* harmony export */   "Qy": function() { return /* binding */ TagType; },
/* harmony export */   "ZP": function() { return /* binding */ TagEmp; },
/* harmony export */   "r7": function() { return /* binding */ StarIcon; },
/* harmony export */   "xo": function() { return /* binding */ StarScore; }
/* harmony export */ });
/* unused harmony exports StarIconBase, Tag, TagGroup, TagProduct, TagBrand, TagCode */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _PUBLIC_P_images_ico_ico_spr_png__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99653);
/* harmony import */ var _PUBLIC_P_images_ico_ico_spr_png__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_PUBLIC_P_images_ico_ico_spr_png__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93391);
/* harmony import */ var _PUBLIC_P_images_ico_ico_star_png__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28317);
/* harmony import */ var _PUBLIC_P_images_ico_ico_star_png__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_PUBLIC_P_images_ico_ico_star_png__WEBPACK_IMPORTED_MODULE_2__);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: inline-block;\n	width: 14px;\n	height: 14px;\n	background: url(",
        ") -1px -27px / 400px 400px no-repeat;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: inline-block;\n	width: 14px;\n	height: 14px;\n	background: url(",
        ") -60px -27px / 400px 400px no-repeat;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	width: 74px;\n	display: inline-block;\n	height: 14px;\n	overflow: hidden;\n	background: url(",
        ") no-repeat;\n	text-align: left;\n\n	span {\n		display: inline-block;\n		height: 14px;\n		overflow: hidden;\n		background: url(",
        ") no-repeat;\n		background-position: left bottom;\n		line-height: 0;\n		vertical-align: top;\n	}\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n			border: 1px solid var(--red-color);\n			color: var(--red-color);\n		"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: flex;\n	height: 20px;\n	padding: 0 10px;\n	font-size: 12px;\n	justify-content: center;\n	align-items: center;\n\n	",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	position: absolute;\n	top: 0;\n	left: 0;\n	display: flex;\n	justify-content: center;\n	align-items: center;\n	z-index: 1;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "#008400"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "#6a5fbc"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "#e0a446"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "#89a852"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "#b94b60"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "#e94c4c"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "#009acf"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "#777"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "#222"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "#c6a3dc"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "#333"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "#7f905e"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "#78909a"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: inline-flex;\n	align-items: center;\n	height: 24px;\n	padding: 0 8px;\n	border-radius: 4px;\n	background-color: ",
        ';\n	color: #fff;\n	font-size: 13px;\n	font-family: "pr-font-regular";\n	box-sizing: border-box;\n	line-height: 1;\n'
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: inline-flex;\n	align-items: center;\n	height: 24px;\n	padding: 0 8px;\n	border-radius: 4px;\n	background-color: ",
        ';\n	color: #fff;\n	font-size: 13px;\n	font-family: "pr-font-regular";\n	box-sizing: border-box;\n	line-height: 1;\n\n	@media print {\n		font-size: 24px;\n		height: 32px;\n	}\n'
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: inline-flex;\n	align-items: center;\n	height: 24px;\n	padding: 0 8px;\n	border-radius: 4px;\n	background-color: ",
        ';\n	color: #fff;\n	font-size: 13px;\n	font-family: "pr-font-regular";\n	box-sizing: border-box;\n	line-height: 1;\n'
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n	display: inline-flex;\n	align-items: center;\n	height: 24px;\n	padding: 0 8px;\n	border-radius: 4px;\n	background-color: #def5e5;\n	color: #11a740;\n	font-size: 13px;\n	font-family: "pr-font-regular";\n	box-sizing: border-box;\n	line-height: 1;\n\n	@media print {\n		font-size: 24px;\n		height: 32px;\n	}\n'
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n	display: inline-flex;\n	align-items: center;\n	height: 24px;\n	padding: 0 8px;\n	border-radius: 4px;\n	background-color: #fdecec;\n	color: #f23f45;\n	font-size: 13px;\n	font-family: "pr-font-regular";\n	box-sizing: border-box;\n	line-height: 1;\n\n	@media print {\n		font-size: 24px;\n		height: 32px;\n	}\n'
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: inline-flex;\n	align-items: center;\n	height: 24px;\n	padding: 0 8px;\n	border-radius: 4px;\n	",
        '\n	font-size: 13px;\n	font-family: "pr-font-regular";\n	box-sizing: border-box;\n	line-height: 1;\n\n	@media print {\n		font-size: 24px;\n		height: 32px;\n	}\n'
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n	display: inline-flex;\n	align-items: center;\n	height: 24px;\n	padding: 0 8px;\n	border-radius: 4px;\n	background-color: #495263;\n	font-size: 13px;\n	font-family: "pr-font-regular";\n	box-sizing: border-box;\n	line-height: 1;\n	color: #fff;\n'
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}



var StarIcon = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].i.withConfig */ .ZP.i.withConfig({
    componentId: "sc-850c5c71-0"
})(_templateObject(), (_PUBLIC_P_images_ico_ico_spr_png__WEBPACK_IMPORTED_MODULE_1___default()));
var StarIconBase = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].i.withConfig */ .ZP.i.withConfig({
    componentId: "sc-850c5c71-1"
})(_templateObject1(), (_PUBLIC_P_images_ico_ico_spr_png__WEBPACK_IMPORTED_MODULE_1___default()));
var StarScore = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-850c5c71-2"
})(_templateObject2(), (_PUBLIC_P_images_ico_ico_star_png__WEBPACK_IMPORTED_MODULE_2___default()), (_PUBLIC_P_images_ico_ico_star_png__WEBPACK_IMPORTED_MODULE_2___default()));
var Tag = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-850c5c71-3"
})(_templateObject4(), function(props) {
    return (props.name === "recommend" || props.name === "promotion") && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject3());
});
var TagGroup = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-850c5c71-4"
})(_templateObject5());
var TagSquare = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-850c5c71-5"
})(_templateObject19(), function(props) {
    if (props.tag === "pkg") {
        // 해외패키지
        return "#5778bb";
    }
    if (props.tag === "fit") {
        // 에어텔
        return "#549ec9";
    }
    if (props.tag === "honey") {
        // 허니문
        return "#c159c0";
    }
    if (props.tag === "golf") {
        // 골프
        return "#4fa344";
    }
    if (props.tag === "cruise") {
        // 크루즈
        return "#5e90e3";
    }
    if (props.tag === "dmt") {
        // 국내여행
        return "#e67f4c";
    }
    if (props.tag === "biz") {
        // 기업단체
        return "#7291a5";
    }
    if (props.tag === "air") {
        // 항공
        return "#57bbb5";
    }
    if (props.tag === "hotel") {
        // 호텔
        return "#895eb5";
    }
    if (props.tag === "tour") {
        // 투어
        return "#e072a4";
    }
    if (props.tag === "rent") {
        // 렌터카
        return "#3a59cc";
    }
    if (props.tag === "semi") {
        // 세미패키지
        return "#009acf";
    }
    if (props.tag === "pilgrimage") {
        // 성지순례
        return "#6a5fbc";
    }
    if (props.tag === "discount") {
        // 특가상품
        return "#b94b60";
    }
    if (props.tag === "tranking") {
        return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject6());
    }
    if (props.tag === "pilgrimage") {
        return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject7());
    }
    if (props.tag === "ticket") {
        return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject8());
    }
    if (props.tag === "local") {
        return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject9());
    }
    if (props.tag === "discount") {
        return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject10());
    }
    if (props.tag === "percent") {
        return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject11());
    }
    if (props.tag === "coupon") {
        return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject12());
    }
    if (props.tag === "other") {
        return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject13());
    }
    if (props.tag === "code") {
        return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject14());
    }
    if (props.tag === "tourtype") {
        return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject15());
    }
    if (props.tag === "pre") {
        return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject16());
    }
    if (props.tag === "arrival") {
        return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject17());
    }
    if (props.tag === "bargain") {
        return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject18());
    }
});
var TagProduct = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-850c5c71-6"
})(_templateObject20(), function(props) {
    if (props.flag === "pkg") {
        // 해외패키지
        return "#5778bb";
    }
    if (props.flag === "fit") {
        // 에어텔
        return "#549ec9";
    }
    if (props.flag === "honey") {
        // 허니문
        return "#c159c0";
    }
    if (props.flag === "golf") {
        // 골프
        return "#4fa344";
    }
    if (props.flag === "cruise") {
        // 크루즈
        return "#5e90e3";
    }
    if (props.flag === "dmt") {
        // 국내여행
        return "#e67f4c";
    }
    if (props.flag === "biz") {
        // 기업단체
        return "#7291a5";
    }
    if (props.flag === "air") {
        // 항공
        return "#57bbb5";
    }
    if (props.flag === "hotel") {
        // 호텔
        return "#895eb5";
    }
    if (props.flag === "tour") {
        // 투어
        return "#e072a4";
    }
    if (props.flag === "rent") {
        // 렌터카
        return "#3a59cc";
    }
    if (props.flag === "semi") {
        // 세미패키지
        return "#009acf";
    }
    if (props.flag === "pilgrimage") {
        // 성지순례
        return "#6a5fbc";
    }
    if (props.flag === "discount") {
        // 특가상품
        return "#b94b60";
    }
});
var TagBrand = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-850c5c71-7"
})(_templateObject21(), function(props) {
    if (props.flag === "premium") {
        // 프리미엄
        return "#222";
    }
    if (props.flag === "light") {
        // 라이트팩
        return "#a6cc25";
    }
    if (props.flag === "percent") {
        // 100% 출발확정
        return "#e94c4c";
    }
});
var TagType = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-850c5c71-8"
})(_templateObject22());
var TagEmp = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-850c5c71-9"
})(_templateObject23());
var TagProcess = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-850c5c71-10"
})(_templateObject24(), function(props) {
    if (props.flag === "impending") {
        /** 마감임박 **/ return "    \n					border: 1px solid #ef8e25;\n					box-sizing: border-box;\n					background: #faf2e9;\n					color: #ef8e25;\n				";
    }
    if (props.flag === "planning") {
        /** 출발예정 **/ return "    \n					border: 1px solid #5f9cbc;\n					box-sizing: border-box;\n					background: #ecf5f9;\n					color: #5f9cbc;\n				";
    }
    if (props.flag === "decided") {
        /** 출발확정 **/ return "    \n					border: 1px solid #e94c4c;\n					box-sizing: border-box;\n					background: #faefe9;\n					color: #e94c4c;\n				";
    }
    if (props.flag === "percent") {
        /** 100%출발확정 **/ return "\n					border: 1px solid #e94c4c;\n					box-sizing: border-box;\n					background: #faefe9;\n					color: #e94c4c;\n				";
    }
    if (props.flag === "deadline") {
        /** 예약마감 **/ return "    \n					border: 1px solid #999999;\n					box-sizing: border-box;\n					background: #f6f6f6;\n					color: #999999;\n				";
    }
});
var TagCode = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-850c5c71-11"
})(_templateObject25());



/***/ }),

/***/ 38502:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93391);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: flex;\n	align-items: center;\n	gap: 5px;\n\n	img {\n		margin-top: -1px;\n	}\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Wrap = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-bc9ab679-0"
})(_templateObject());
var AirlineIcon = function(param) {
    var title = param.title, img = param.img;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Wrap, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                src: img,
                alt: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("em", {
                children: title
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AirlineIcon);


/***/ }),

/***/ 28317:
/***/ (function(module) {

module.exports = "data:image/png;base64,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"

/***/ })

}]);